/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) { 
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */ 





document.addEventListener("DOMContentLoaded", function() {
  var customGridItems = document.querySelectorAll('.CustomPage_grid-item');

  if(customGridItems) {
    var galleryItems = [];


    for (var i = 0; i < customGridItems.length; i++) {

      var item = {
        src: customGridItems[i].getAttribute('href'),
        w: +(customGridItems[i].getAttribute('data-width')),
        h: +(customGridItems[i].getAttribute('data-height')),
        title: customGridItems[i].getAttribute('data-title')
      };

      galleryItems.push(item);
    }
    
     var delegateRoot = new domDelegate.Delegate(document.body);

    for (var i = 0; i < customGridItems.length; i++) {
      customGridItems[i].addEventListener("mouseenter", function(e) {
        var parenElement = e.target.parentElement;
        parenElement.classList.add('element-hovered');
      });
      customGridItems[i].addEventListener("mouseleave", function(e) {
        var parenElement = e.target.parentElement;
        parenElement.classList.remove('element-hovered');
      });

      customGridItems[i].addEventListener("click", function(e) {
        e.preventDefault();

                
        var customPagePswp = document.querySelectorAll('.pswp')[0],
            options = {
              index: +(e.target.closest('.CustomPage_grid-item').getAttribute('data-index')),
              bgOpacity: 0.8,
              captionEl: true,
              tapToClose: true,
              shareEl: false,
              loop: true,
              closeOnScroll: false,
              showHideOpacity: true,
              showAnimationDuration: 500,
              history: false,
              closeOnVerticalDrag: false,
              allowPanToNext: false,
              pinchToClose: false,
 //             scaleMode: 'zoom',
//               addCaptionHTMLFn: function(item, captionEl, isFake) {
//                 if(!item.title) {
//                   captionEl.children[0].innerHTML = '';
//                   return false;
//                 }

//                 captionEl.children[0].innerHTML = item.title + '<br>' + 'by' + item.author;
//                 return true;
//               },
//               getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
//                 debugger;
//                 if (isMouseClick) {
//                   return 1.6;
//                 } else {
//                   return item.initialZoomLevel < 0.7 ? 1 : 1.33;
//                 }
//               },
              getThumbBoundsFn: function getThumbBoundsFn(index) {
                var thumbnail = document.querySelector('.CustomPage_grid-item:nth-child(' + (parseInt(index) + 1) + ') img'),
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect();

                return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
              }
            };

        var customPageGallery = new PhotoSwipe(customPagePswp, false, galleryItems, options);
        
       
               
        customPageGallery.listen('unbindEvents', function() { 
           delegateRoot.off('pswpTap');
        });

        customPageGallery.listen('initialZoomIn', function () {
          document.querySelector('.pswp__ui').classList.remove('pswp__ui--hidden');
        });
        customPageGallery.listen('initialZoomOut', function () {
          document.querySelector('.pswp__ui').classList.add('pswp__ui--hidden');
        });

//         customPageGallery.listen('doubleTap', function(point) {
//           var initialZoomLevel = customPageGallery.currItem.initialZoomLevel;

//           if (customPageGallery.getZoomLevel() !== initialZoomLevel) {
//             customPageGallery.zoomTo(initialZoomLevel, point, 333);
//           } else {
//             customPageGallery.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
//           }
//         });


        
//         customPageGallery.listen('gettingData', function(index, item) {

//             var caption = customPagePswp.querySelector('.pswp__caption__center');
           
//             if (caption != null) {
//               caption.innerHTML = item.title;
//             }
//         });
        
        delegateRoot.on('pswpTap', '.pswp__scroll-wrap',function(event) {
          if (!event.detail || event.detail.pointerType === 'mouse') {
            if (event.target.classList.contains('pswp__img')) {
              customPageGallery.toggleDesktopZoom(event.detail.releasePoint);
            }
          } else {
            if (event.target.classList.contains('pswp__button')) {
              return;
            }

            event.target.closest('.pswp').querySelector('.pswp__ui').classList.toggle('pswp__ui--hidden');
          }
        });
        delegateRoot.on('pswpTap', '.pswp__button--close', customPageGallery.close);
        delegateRoot.on('pswpTap', '.pswp__button--prev', customPageGallery.prev);
        delegateRoot.on('pswpTap', '.pswp__button--next', customPageGallery.next);
        
        customPageGallery.init();
      
      });
    }
    
  }
  
  var CustomPage_leftSide = document.querySelector('.CustomPage_left-side h2');

  var isInViewportTop = function (elem) {
    var bounding = elem.getBoundingClientRect();
    return (
        bounding.top <= (window.innerHeight || document.documentElement.clientHeight)
    );
};
  
  if(CustomPage_leftSide) {
    var Header__height = document.querySelector('.Header__Wrapper').offsetHeight + 50;
//     var Footer__height = document.querySelector('#section-footer').offsetHeight ;
//     var correct_width = document.body.clientHeight - (Footer__height+Header__height);
   
//     document.querySelector('.CustomPage_left-side').style.width = correct_width+"px";
    //var left_size_width = CustomPage_leftSide.offsetWidth + Header__height + 100;
    CustomPage_leftSide.style.paddingRight = Header__height+"px";
    
     
    
    window.addEventListener('resize', function() {
      var CustomPage_leftSide = document.querySelector('.CustomPage_left-side h2');
      if(CustomPage_leftSide) {
        var Header__height = document.querySelector('.Header__Wrapper').offsetHeight + 50;
        //var left_size_width = CustomPage_leftSide.offsetWidth + Header__height + 100;
        CustomPage_leftSide.style.paddingRight = Header__height+"px";
      }
    });
    
    window.addEventListener('scroll', function() {
      var CustomPage_leftSide = document.querySelector('.CustomPage_left-side h2');
      if(isInViewportTop(document.querySelector('#section-footer'))) {
         document.querySelector('.CustomPage_left-side').style.position = "absolute";
      }else{
        document.querySelector('.CustomPage_left-side').style.position = "fixed";
      }
    });
  }
  
  var customPageBackTopBtn = document.getElementById('cutom-page_back-top-button');

  if (customPageBackTopBtn != null) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 300) {
        customPageBackTopBtn.classList.add('show');
      } else {
        customPageBackTopBtn.classList.remove('show');
      }
    });

    customPageBackTopBtn.addEventListener("click", function(e) {
      e.preventDefault();
     
      scrollToTop(300);
    });

    function scrollToTop(scrollDuration) {
      var scrollStep = -window.scrollY / (scrollDuration / 15),
          scrollInterval = setInterval(function(){
            if ( window.scrollY != 0 ) {
              window.scrollBy( 0, scrollStep );
            }
            else clearInterval(scrollInterval); 
          },15);
    }
  }
  
//   var customDropdownWrapper = document.querySelector('.custom-dropdown');
//   var customDropdown = document.querySelector('.custom-dropdown .main-field');
  var dropdownListElements = document.querySelectorAll('.custom-dropdown-list-item');

  //   if (customDropdownWrapper != null) {
  document.addEventListener('click', function(event) {

    var el = event.target;
    if(el.closest('.custom-dropdown') && el.classList.contains('custom-dropdown')) {

       var customDropdownWrapper = el;
      
       if(!customDropdownWrapper.classList.contains('custom-dropdown')) {
          customDropdownWrapper = customDropdownWrapper.closest('.custom-dropdown');
        }
      
       var customDropdown = customDropdownWrapper.querySelector('.main-field');
     

      

    } else {
      var customDropdownWrapper = document.querySelector('.custom-dropdown');
      
      if(customDropdownWrapper) {
        var isClickInside = customDropdownWrapper.contains(event.target);

        var customDropdown = document.querySelector('.custom-dropdown .main-field');
        
        if (!isClickInside && !event.target.classList.contains("ColorSwatch__Radio")) {
          document.querySelector('.custom-dropdown-list').classList.remove("open");
          customDropdown.classList.remove("top-list");
          customDropdown.classList.remove("bottom-list");
        }
      }
    }
  });
  //   }

  //   if (customDropdown != null) {

  document.addEventListener('click', function(e) {
    //     customDropdown.addEventListener("click", function (e) {
    var el = e.target;
    if(el.closest('.custom-dropdown-wrapper')) {

      if(!el.classList.contains('main-field')) {
        el = el.closest('.main-field');
      }

      var customDropdownWrapper = el;

      if(customDropdownWrapper) {
        if(!customDropdownWrapper.classList.contains('custom-dropdown')) {
          customDropdownWrapper = customDropdownWrapper.closest('.custom-dropdown');
        }

        var customDropdown = customDropdownWrapper.querySelector('.main-field');





        var customDropdownList = el.nextElementSibling;      
        var bounding = customDropdown.getBoundingClientRect();
        var dropdownFromTop = bounding.top;

        if (customDropdownList != null) {
          if (customDropdownList.classList.contains('open')) {
            customDropdownList.classList.remove("open");
            customDropdown.classList.remove("top-list");
            customDropdown.classList.remove("bottom-list");
          } else {
            customDropdownList.classList.add("open");
            customDropdown.classList.add("bottom-list");
          }
        }
      }
    }

  });    
//   }

 
  document.addEventListener('click', function(e) {

    var el = e.target;
    if(el.classList.contains('custom-dropdown-list-item') || el.closest('.custom-dropdown-list-item')) {
      if(!el.classList.contains('custom-dropdown-list-item')) {
        el = el.closest('.custom-dropdown-list-item');
      }

      var elementParent = el.parentElement;
      var dropdownWrapper = elementParent.previousElementSibling;
      var elementContent = el.innerHTML;


      //var optionsSelect = document.querySelector('.single-option-selector');

      var optionValue = el.querySelector("span").innerHTML;
      if(elementParent.querySelector('.custom-dropdown-list-item.selected')) {
        elementParent.querySelector('.custom-dropdown-list-item.selected').classList.remove("selected");
      }
      el.classList.add("selected");
      dropdownWrapper.classList.remove("top-list");
      dropdownWrapper.classList.remove("bottom-list");
      elementParent.classList.remove("open");
      dropdownWrapper.innerHTML = elementContent;


      var color_value = el.getAttribute('data-color-value');
      var ColorSwatch__Radio_arr = el.closest('.ProductForm__Variants').querySelectorAll('.ColorSwatch__Radio');
      for(var i=0;i < ColorSwatch__Radio_arr.length;i++) {
        var ColorSwatch__Radio = ColorSwatch__Radio_arr[i];
        var val = ColorSwatch__Radio.getAttribute('data-value');
        if(val == color_value) {
          ColorSwatch__Radio.click();
          break;
        }
      }
    }

  });


  function debounce(func, wait, immediate) { 
    var timeout;
  
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  var searchValue = debounce(function(event) {

    var openDropddown = event.target.querySelector('.custom-dropdown-list.open');
    var keyValueInput = event.target.querySelector('.keys-value');
    if (openDropddown != null) {
      
      var searchValue = keyValueInput.value;
      
       var dropdownListElements = event.target.querySelectorAll('.custom-dropdown-list-item');
      
      for (var i = 0; i < dropdownListElements.length; i++) {
        var dropdownElement = dropdownListElements[i];
        var elementParent = dropdownElement.parentElement;
        var dropdownWrapper = elementParent.previousElementSibling;
        if (dropdownElement != null) { 
          var optionValue = dropdownElement.querySelector("span").innerHTML.toLowerCase();
          if (optionValue.indexOf('#') > -1) {
          	optionValue = optionValue.replace('#','');
          }
          if (optionValue.indexOf(searchValue) >= 0 && keyValueInput.value != '') {
            var elementContent = dropdownElement.innerHTML;
            dropdownElement.scrollIntoView({block: "nearest"});
            if(elementParent.querySelector('.custom-dropdown-list-item.selected')) {
            elementParent.querySelector('.custom-dropdown-list-item.selected').classList.remove("selected");
            }
            dropdownElement.classList.add("selected");
            dropdownWrapper.innerHTML = elementContent;
            
            
            var color_value = dropdownElement.getAttribute('data-color-value');
            var ColorSwatch__Radio_arr = dropdownElement.closest('.ProductForm__Variants').querySelectorAll('.ColorSwatch__Radio');
            for(var i=0;i < ColorSwatch__Radio_arr.length;i++) {
              var ColorSwatch__Radio = ColorSwatch__Radio_arr[i];
              var val = ColorSwatch__Radio.getAttribute('data-value');
              if(val == color_value) {
                ColorSwatch__Radio.click();
                break;
              }
            }
            
            break;
          }
        }
      }
      keyValueInput.value = '';
    }
  }, 1000);



  function resizeProductImagesCarousel() {
    $('.ProductImagesCarousel.flickity-enabled').each(function(index,item) {
      var flkty = Flickity.data(item);
      console.log('debounce resize');
      flkty.resize();
      flkty.reloadCells();
      flkty.reposition();
    });
     $('.show_origin_size_image .Slideshow__Carousel.flickity-enabled').each(function(index,item) {
      var flkty = Flickity.data(item);
      console.log('debounce resize');
      flkty.resize();
      flkty.reloadCells();
      flkty.reposition();
    });
  };
  
  var reLoadProductImagesCarousel = debounce(function(event) {
    resizeProductImagesCarousel();
  }, 500);

  reLoadProductImagesCarousel();
  window.addEventListener("resize", reLoadProductImagesCarousel);

  

  document.addEventListener("keyup", searchValue);
  document.addEventListener("keyup", function(event) {
   
    var openDropddown = event.target.querySelector('.custom-dropdown-list.open');
    var keyValueInput = event.target.querySelector('.keys-value');
    if (openDropddown != null) {
      keyValueInput.value = keyValueInput.value + String.fromCharCode(event.keyCode).toLowerCase();
    }
  })




  var GridProductFormButton = document.querySelectorAll('.ProductForm .ProductForm__AddToCart');

  if(GridProductFormButton.length) {
    document.addEventListener('click', function(e) {
      
      var this_btn = e.target;
      if(this_btn.classList.contains('ProductForm__AddToCart') || this_btn.closest('.ProductForm__AddToCart') ) {
        var parent_form =  this_btn.closest('.ProductForm');
        if(this_btn.closest('.ProductItem')) {
        var ProductItem__ColorSwatchList = this_btn.closest('.ProductItem').querySelector('.ProductItem__ColorSwatchList');
        }
        if(ProductItem__ColorSwatchList) {
          var active_radio = ProductItem__ColorSwatchList.querySelector('.ColorSwatch__Radio:checked');
          if(!active_radio) {
            var SwatcherColorError = e.target.closest('.ProductItem').querySelector('.SwatcherColorError');
            if(window.innerWidth > 640) {
              parent_form.querySelector('.ProductForm__AddToCart .add_to_cart_desktop').innerText = window.languages.productFormAddToCart;	
            } else {
              parent_form.querySelector('.ProductForm__AddToCart .add_to_cart_mobile').innerText = window.languages.productFormAddToCartMobile;	
            }
            parent_form.querySelector('.ProductForm__AddToCart').classList.remove('no-visible');
            if(SwatcherColorError){
            SwatcherColorError.classList.add('showError');
            setTimeout(function () {
              SwatcherColorError.classList.remove('showError');
            }, 2500);
            }

            e.preventDefault();
            e.stopPropagation();
            return false;

          }
        }


        var ProductForm__Error = parent_form.querySelectorAll('.ProductForm__Error');
        if(ProductForm__Error) {
          for(var i=0;i < ProductForm__Error.length;i++) {
            var el = ProductForm__Error[i];
            el.parentNode.removeChild(el);
          }
        }
      }
    });


    document.addEventListener('change', function(e) {

      if(e.target.closest('.ProductForm__Option--collection')) {
        var parent_form =  e.target.closest('.ProductForm');

        var elem = e.target;
        if(!elem.classList.contains('mainProductSelect')) {
          elem = elem.closest('select');
        }




        var variantOption = elem.value;


        var ProductItem__ColorSwatchList = elem.closest('.ProductItem').querySelector('.ProductItem__ColorSwatchList');

        if(ProductItem__ColorSwatchList) {
          var active_radio = ProductItem__ColorSwatchList.querySelector('.ColorSwatch__Radio:checked');

          if(active_radio) {
            var active_radio_val = active_radio.value;


            var productData = parent_form.querySelector('[data-product-json]').text;
            var productJSON = JSON.parse(productData);
            var productVariantObj = productJSON.product.variants;

            var option1 = active_radio_val || null,
                option2 = variantOption || null;


            for (var i=0,length=productVariantObj.length; i<length; i++) {
              var productVar = productVariantObj[i];
              if(productVar.option1 != null){productVar.option1 = productVar.option1.replace(/\s{2,}/g, ' ');} 
              if(productVar.option2 != null){productVar.option2 = productVar.option2.replace(/\s{2,}/g, ' ');} 
              if(option1==productVar.option1 && option2==productVar.option2){
                variantOption = productVar.title;
                break;
              }
            }
          } else {

            var SwatcherColorError = elem.closest('.ProductItem').querySelector('.SwatcherColorError');
             if(SwatcherColorError){
            SwatcherColorError.classList.add('showError');
            setTimeout(function () {
              SwatcherColorError.classList.remove('showError');
            }, 2500);
          }

            return false;
          }
        }

        var mainSelect = parent_form.querySelector('.mainProductSelect');

     



        if(elem != mainSelect) {
          for(var i=0;i < mainSelect.querySelectorAll('option').length;i++) {
            var option = mainSelect.querySelectorAll('option')[i];
            var optionVal = option.text;

            option.removeAttribute('selected');
            if(optionVal == variantOption) {
              option.setAttribute('selected','selected');
              break;
            }
          }
        }


        if(window.innerWidth <= 640) {
          parent_form.querySelector('.ProductForm__AddToCart').setAttribute('data-action','add-to-cart');
        }
        parent_form.querySelector('.ProductForm__AddToCart').click();
        parent_form.querySelector('.ProductForm__AddToCart').classList.remove('no-visible');
      }
    });
  }

    document.addEventListener('change', function(e) {
      if(e.target.classList.contains('ColorSwatch__Radio') && e.target.closest('.ProductItem--collection')) {
        var el = e.target;
        var val = el.value;
        var ProductItem = el.closest('.ProductItem');
        
        if(ProductItem) {
          var main_select = ProductItem.querySelector('.mainProductSelect');
          
         
          for(var i=0;i < main_select.querySelectorAll('option').length;i++) { 
            var option = main_select.querySelectorAll('option')[i];
            var optionVal = option.text;

            option.removeAttribute('selected');
            if(optionVal.indexOf(val) >= 0) {
              option.setAttribute('selected','selected');
              break;
            }
          }

        }

      }
    });    
  

  var ProductItem__ColorSwatchList_Elems = document.querySelectorAll('.ProductItem__ColorSwatchList');
  if(ProductItem__ColorSwatchList_Elems.length) {

    //     var groupCells_options = 10;
    if(window.innerWidth <= 640) {
      var  groupCells_options = 4;


      var config = {
        "prevNextButtons": true,
        "pageDots": false,
        cellAlign: 'left', 
        "wrapAround": false,
        groupCells: groupCells_options,
        adaptiveHeight: false,
        contain: true
      };

      for(var i=0;i < ProductItem__ColorSwatchList_Elems.length;i++) {
        var ProductItem__ColorSwatchList = ProductItem__ColorSwatchList_Elems[i];
        var ProductItem__ColorSwatchItem_arr = ProductItem__ColorSwatchList.querySelectorAll('.ProductItem__ColorSwatchItem, .ProductItem__SizeSwatchItem');


        if(ProductItem__ColorSwatchItem_arr.length > groupCells_options ) {
          var ProductItem__ColorSwatchList_Block = ProductItem__ColorSwatchList.querySelector('.ProductItem__ColorSwatchList_Block');
          var ProductItem__ColorSwatchList_Block_flkty = new Flickity(ProductItem__ColorSwatchList_Block,config);
        }
      }
    }

  }
  

  var CheckedColorSwatchItem_arr = document.querySelectorAll('.linked_options_wrapper .ColorSwatch__Radio[checked]');
  if(CheckedColorSwatchItem_arr.length) {

    document.querySelectorAll('.linked_options_wrapper').forEach(function(item,index) {

      var CheckedColorSwatchItem_arr = item.querySelectorAll('.ColorSwatch__Radio[checked]');
      if(CheckedColorSwatchItem_arr.length) {
        for(var i=0;i < CheckedColorSwatchItem_arr.length;i++) {

          var CheckedColorSwatchItem = CheckedColorSwatchItem_arr[i];
          var available_sizes = CheckedColorSwatchItem.getAttribute("data-available-options");

          var sizeSwatchItem_arr = CheckedColorSwatchItem.closest('.linked_options_wrapper').querySelectorAll('.linked_options_wrapper .SizeSwatch__Radio');

          for(var k=0;k < sizeSwatchItem_arr.length;k++) {
            var sizeSwatchItem = sizeSwatchItem_arr[k];
            if(available_sizes.indexOf(sizeSwatchItem.value) == -1){
              sizeSwatchItem.closest(".ProductItem__SizeSwatchItem").style.display = "none";
            }
          }
        }
      }
    });


  }


  var featured_collections_sections = document.querySelectorAll('.new-features-featured-collections-section');
  if(featured_collections_sections) {

        function ResponsiveFeauturedCollectionCarouselButton () {

      let intViewportWidth = window.innerWidth;
      if(intViewportWidth >= 1008)  {
        for(var i=0;i < featured_collections_sections.length;i++) {
          var featured_collections_section = featured_collections_sections[i];
          var carousel_buttons = featured_collections_section.querySelectorAll('.ProductList--carousel > .flickity-prev-next-button');
          if(carousel_buttons && carousel_buttons.length > 0 ) {
            var image_block = featured_collections_section.querySelector('.ProductItem__Image');
            if(image_block) {
              var image_block_height = image_block.offsetHeight;
              var button_height = carousel_buttons[0].offsetHeight;
              var buttons_top_position = (image_block_height / 2) - (button_height / 2);

              carousel_buttons.forEach(function(el, index, array){
                el.style.top = buttons_top_position+'px';
              });
            }
          }
        }
      }
    }
    ResponsiveFeauturedCollectionCarouselButton();
    window.onresize = ResponsiveFeauturedCollectionCarouselButton;

  }

  $('body').on('input','.focus_input', function(e) {
    var val = $(this).val();
    if(val.length) {
      $(this).removeClass('focus_input');
    }
  });

  $('body').on('click', '.CustomerModal_address .Form__Submit', function(e) {
    e.preventDefault();
    var submit_form = true;
    $(this).closest('form').find('.Form__Input').each(function () {
      if($(this).val().length == 0) {
        submit_form = false;
        $(this).addClass('focus_input');
      } else {
        $(this).removeClass('focus_input');
      }
    });
    if($(this).closest('form').find('.cc_code1').val().length <= 5) {
      $(this).closest('form').find('.cc_code1').addClass('focus_input');
      return false;
    } else {
      $(this).closest('form').find('.cc_code1').removeClass('focus_input');
    }

    if(submit_form) {
      $(this).closest('form').trigger('submit');
    }
  });
  
  $('body').on('click', '#recover_customer_password .Form__Submit', function(e) {
    e.preventDefault();
    var submit_form = true;
    $(this).closest('form').find('.Form__Input').each(function () {
      if($(this).val().length == 0) {
        submit_form = false;
        $(this).addClass('focus_input');
      } else {
        $(this).removeClass('focus_input');
      }
    });

    if(submit_form) {
      $(this).closest('form').trigger('submit');
    }
  });

  $('body').on('click', '#customer_login .Form__Submit', function(e) {
    e.preventDefault();
    var submit_form = true;

    $(this).closest('form').find('.Form__Input').each(function () {
      if($(this).val().length == 0) {
        submit_form = false;
        $(this).addClass('focus_input');
      } else {
        $(this).removeClass('focus_input');
      }
    });

    if(submit_form) {
      $(this).closest('form').trigger('submit');
    }
  });
  $('body').on('click', '#create_customer .Form__Submit', function(e) {
    e.preventDefault();
    debugger;
    var submit_form = true;
    $(this).closest('form').find('.Form__Input').each(function () {
      if($(this).val().length == 0) {
        submit_form = false;
        $(this).addClass('focus_input');
      } else {
        $(this).removeClass('focus_input');
      }
    });

    var agree_checkbox = $(this).closest('form').find('.agree_checkbox');
    if(agree_checkbox.length) {
      if(!agree_checkbox.is(':checked')) {
        submit_form = false;
        agree_checkbox.parent().addClass('focus_error');

        setTimeout(function() {
          agree_checkbox.parent().removeClass('focus_error');
        },2000);

      }
    }
    if(submit_form) {
      $(this).closest('form').trigger('submit');
    }
  });
  $('body').on('click', '.change_form_btn', function(e) {
    var form = $(this).closest('form');
    form.find('.Form__Input').each(function () {
      $(this).val('');
      $(this).removeClass('focus_input');
    });
  });
  $('body').on('input', '.header_desktop_form  .Search__Input', function(e) {
    e.preventDefault();

    var val = $(this).val();
    var Search_Wrapper = $('#Search');
    var AjaxSearchInput = $('#Search .Search__Input');

    if(val.length == 0) { 
      Search_Wrapper.attr('aria-hidden', 'true');
    } else {
     
      if(AjaxSearchInput.length) {
        AjaxSearchInput.val(val);
        AjaxSearchInput[0].dispatchEvent(new Event('input'));
        AjaxSearchInput[0].dispatchEvent(new Event('keydown'));
        setTimeout(function() {
          Search_Wrapper.attr('aria-hidden', 'false');
        },1000);
      }
    }
  });
  


  
  const isElementInViewport = el => {
    const scroll = window.scrollY || window.pageYOffset;
    
    var headerHeight = document.querySelector('#section-header').offsetHeight;
    const boundsTop = el.getBoundingClientRect().top + scroll

    const viewport = {
      top: scroll + headerHeight, 
      bottom: scroll + window.innerHeight + headerHeight,
    }

    const bounds = {
      top: boundsTop,
      bottom: boundsTop + el.clientHeight,
    }

    return ( bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom ) 
    || ( bounds.top <= viewport.bottom && bounds.top >= viewport.top );
  }

  function sliderReturnSlide () {
    $('.ProductImagesCarousel').each(function () {
      if($(this).hasClass('flickity-enabled')) {
        var inViewport = isElementInViewport($(this)[0]);
        
        var flkty = Flickity.data( this ); 
        var selectedIndex  = flkty.selectedIndex;

        if(inViewport == false) {
          if(selectedIndex != 0) {
            flkty.selectCell(0);
          }
        }
      }
    });
  };

  var returnDefaultSlide = debounce(function(event) {
    sliderReturnSlide();
  }, 50);

  document.addEventListener("scroll", returnDefaultSlide);
  

  
  $('body').on('input','.spr-form-input', function(e) {
    var val = $(this).val();
    if(val.length == 0) {
      $(this).addClass('spr-form-input-error');
    } else {
      $(this).removeClass('spr-form-input-error');
    }
  });

  $('body').on('click','.filter_toggle_btn', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');

    var CollectionInner__Sidebar  = $('.CollectionInner__Sidebar');
    CollectionInner__Sidebar.toggleClass('hide_filters');

    setTimeout(function () {
      $('.ProductImagesCarousel.flickity-enabled').each(function(index,item) {
        var flkty = Flickity.data(item);
        flkty.reloadCells();
      });

    },300);

  });
	
  $('body').on('mouseover', '.MegaMenu .MegaMenu__HoverLink', function(e) {

    var link_handle = $(this).attr('data-item-handle');
    var megaMenu__Inner = $(this).closest('.MegaMenu__Inner');
    var additional__Megamenu_images__Blocks  = megaMenu__Inner.find('.Additional__Megamenu_images');
    var default__Megamenu_images__Blocks = megaMenu__Inner.find('.Default__Megamenu_images');  

    var show_default_block = true;

    if(additional__Megamenu_images__Blocks.length) {
      additional__Megamenu_images__Blocks.each(function(index,item) {

        var item = $(item);
        var block_handle = item.attr('data-navigation_mega_menu');
        if(block_handle == link_handle) {
          show_default_block = false;
          default__Megamenu_images__Blocks.addClass('no-js');
          item.removeClass('no-js');
        } else {
          item.addClass('no-js');
        }
      });
      if(show_default_block) {
        default__Megamenu_images__Blocks.removeClass('no-js');
      }
    }
  });

  var CarouselArr = $('.Carousel');
  if(CarouselArr.length) {
    CarouselArr.each(function () {
      var $flickity = Flickity.data($(this)[0]);
      if(typeof $flickity != "undefined"){
      $flickity.resize();
      }
    })
  }
  


//   var sample_collection_modal = $('.sample_collection_modal');
//   if(sample_collection_modal.length) {

//     $('body').on('click.sampleProductModal', '[name="checkout"]', function(e) {
//       e.preventDefault();      
//       $.colorbox({inline:true, href:".sample_collection_modal", fixed: true, maxWidth: "1200px", height: "100%", width: '100%', scrolling: true, overlayClose:false, className:"sample_collection-popup-colorbox-wrapper"});
//     });
//     $(document).bind('cbox_complete', function(){
//       if(sample_collection_modal.closest('#cboxLoadedContent')) {
//         sample_collection_modal.find('.flickity-enabled').each(function(index,item) {
//           var flkty = Flickity.data(item);
//           flkty.resize();
//         });
//         $(window).trigger('resize');
//       }
//     });

//     $('body').on('click', '.SubmitSampleCollection', function(e) {
//       e.preventDefault();
//       var self = this;
      
//       var sample_collection_modal = $(this).closest('.sample_collection_modal');
//       var selectedBtnsSize = sample_collection_modal.find('.SelectProduct.selected').length;
//       if(selectedBtnsSize) {
//         var itemsArr = [];
//         sample_collection_modal.find('.SelectProduct.selected').each(function () {
//           var $this = $(this);
//           var gridParent = $this.closest('.ProductItem');
//           var variantId = gridParent.find('.ProductForm [name="id"]').val() * 1;
//           var itemObj = {
//             'id': variantId,
//             'quantity': 1
//           };
//           itemsArr.push(itemObj);

//         });
//         console.log(itemsArr);
        
        
//         var formData = {
//           'items': itemsArr
//         };

//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify(formData)
//         }).then(function (response) {
//           if (response.ok) {
//             self.removeAttribute('disabled');
//             console.log(response);
//             debugger;

//           } else {
//             response.json().then(function (content) {
//               var errorMessageElement = document.createElement('span');
//               errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
//               errorMessageElement.innerHTML = content['description'];
//               self.removeAttribute('disabled');
//               self.insertAdjacentElement('afterend', errorMessageElement);
//               setTimeout(function () {
//                 errorMessageElement.remove();
//               }, 2500);
//             });
//           }
//         });

//       }
//       $.colorbox.close();

//       var giftWrappingEl = $('#gift-wrapping');
//       var cartNoteEl = $('#cart-note');
//       if(giftWrappingEl.length) {
//         var isChecked = giftWrappingEl.prop('checked');
//         if(isChecked) {
//           var cartNoteVal = cartNoteEl.val();
//           if(cartNoteVal.length == 0) {

//             var defaultNoteMessage = 'See Additional Details';

//             fetch(window.theme.localeRootUrl + '/cart/update.js', {
//               body: JSON.stringify({ note: defaultNoteMessage }),
//               credentials: 'same-origin',
//               method: 'POST',
//               headers: {
//                 'Content-Type': 'application/json',
//                 'X-Requested-With': 'XMLHttpRequest' 
//               }
//             }).then(response => response.json())
//             .then(data => { console.log(data) });;
//           }
//         }
//       }

//       $('body').off('click.sampleProductModal');
//       $('[name="checkout"]').trigger('click');

//     });
//     $('body').on('click', '.SelectProduct', function(e) {
//       e.preventDefault();
//       var _this = $(this);
//       _this.toggleClass('selected');

//       var gridWrapper  = _this.closest('.sample_collection_grid');
//       var sample_collection_choose_limit = $('.sample_collection_choose_limit');
//       var selectedItemsSize = gridWrapper.find('.SelectProduct.selected').length;
//       var productsLimit = sample_collection_choose_limit.attr('data-limit');
//       var SectionHeader__MaxLimit_Heading = $('.SectionHeader__MaxLimit_Heading');
//       var SectionHeader__Heading = $('.sample_collection_modal .SectionHeader__Heading');

//       if(_this.hasClass('selected')) {
//         _this.html('Remove');
//         _this.removeClass('Button--secondary');
//         _this.addClass('Button--primary');
//       } else {
//         _this.html('Select');
//         _this.removeClass('Button--primary');
//         _this.addClass('Button--secondary');
//       }
      
      
//       if(selectedItemsSize >= productsLimit) {
//         gridWrapper.find('.SelectProduct:not(.selected)').each(function() {
//         	$(this).addClass('disabled');
//         });
//         SectionHeader__Heading.addClass('no-js');
//         SectionHeader__MaxLimit_Heading.removeClass('no-js');
//       } else {
//         if(gridWrapper.find('.SelectProduct.disabled').length > 0) {
//           gridWrapper.find('.SelectProduct:not(.selected)').each(function() {
//             $(this).removeClass('disabled');
//           });
//           SectionHeader__Heading.removeClass('no-js');
//           SectionHeader__MaxLimit_Heading.addClass('no-js');

//         }
//         sample_collection_choose_limit.html(productsLimit - selectedItemsSize);
//       }
//     });
//     $('body').on('click', '.remove_selected_products', function(e) {
//       e.preventDefault();
//       var gridWrapper  = $('.sample_collection_grid');
//       var sample_collection_choose_limit = $('.sample_collection_choose_limit');
//       var productsLimit = sample_collection_choose_limit.attr('data-limit');
//       var SectionHeader__MaxLimit_Heading = $('.SectionHeader__MaxLimit_Heading');
//       var SectionHeader__Heading = $('.sample_collection_modal .SectionHeader__Heading');
      
//       gridWrapper.find('.SelectProduct').each(function() {
//         $(this).removeClass('selected');
//         $(this).removeClass('disabled');
//         $(this).removeClass('Button--primary');
//         $(this).addClass('Button--secondary');
//         $(this).html('Select');
//         sample_collection_choose_limit.html(productsLimit);
//         SectionHeader__Heading.removeClass('no-js');
//         SectionHeader__MaxLimit_Heading.addClass('no-js');
//       });
//     });

  //   }


  var quick_buy = document.querySelector('.quick-buy');
  if(quick_buy) {
    document.addEventListener('scroll', function(e) {

      var ProductAsideOffset =  $('#ProductAside').offset().top;
      var static_ProductForm = $('.Product__InfoWrapper .ProductForm');
      var static_ProductFormBottomOffset = static_ProductForm.offset().top + static_ProductForm.height();
      var windowWidth = $(window).width();

      var window_scrollY = window.scrollY;
      var header = document.querySelector('.shopify-section--header');
      var scrollY = header.offsetHeight + window_scrollY;


      if(windowWidth > 640) {
        if(scrollY > ProductAsideOffset) {
          quick_buy.classList.add('quick-buy--visible');
        } else {
          quick_buy.classList.remove('quick-buy--visible');
        }
      } else {
        if(scrollY > static_ProductFormBottomOffset) {
          quick_buy.classList.add('quick-buy--visible');
        } else {
          quick_buy.classList.remove('quick-buy--visible');
        }
      }
    });
    $('body').on('click','.close-quick-buy', function(e) {
      e.preventDefault();
      var parent = $(this).closest('.quick-buy');
      parent.removeClass('quick-buy--visible');
      setTimeout(function() {
        parent.addClass('no-js');
      },500);
    });
  }

  $('body').on('click.checkCartAttributes', '[name="checkout"]', function(e) {
    e.preventDefault();      

    var giftWrappingEl = $('#gift-wrapping');
    var cartNoteEl = $('#cart-note');
    if(giftWrappingEl.length) {
      var isChecked = giftWrappingEl.prop('checked');
      if(isChecked) {
        var cartNoteVal = cartNoteEl.val();
        if(cartNoteVal.length == 0) {

          var defaultNoteMessage = 'See Additional Details';
          fetch(window.theme.localeRootUrl + '/cart/update.js', {
            body: JSON.stringify({ note: defaultNoteMessage }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' 
            }
          }).then(response => response.json())
          .then(data => { console.log(data) });;
        }
      }
    }

    $('body').off('click.checkCartAttributes');
    $(this).trigger('click');


  });
  $('body').on('click','.MobileDrawer_Close', function(e) {
    e.preventDefault();

    $('#mobile-sidebar-cart').removeClass('active');
    document.documentElement.classList.remove('no-scroll'); 
    document.querySelector('.PageOverlay').classList.remove('is-visible');
  });
  
  $('.PageOverlay').on("click", function(){
    $('#mobile-sidebar-cart').removeClass('active');
  });
 


  $('body').on('click','.gift-message__remove', function(e) {
    e.preventDefault();
    $(this).closest('.gift-message__textarea_wrapper').find('.Cart__Note').val('');
    $(this).closest('.gift-message__textarea_wrapper').find('.gift-message__textarea_length').html('6 line(s) left');
    $(this).closest('.gift-message__textarea_wrapper').find('.Cart__Note')[0].dispatchEvent(new Event('change', { bubbles: true }));
  });

  if($('#modal-quick-view').length) {
    document.addEventListener('click', function(e) {
      var el = e.target;
      var elId = el.getAttribute('id');
      if(elId == 'modal-quick-view') {
      	document.querySelector('#modal-quick-view [data-action="close-modal"]').dispatchEvent(new Event('click', { bubbles: true }));
      }
    });
  }

  $('body').on('keypress input','#cart-note', function(e) {

   
    var isGiftwrapper = $(this).closest('.gift-message__textarea_wrapper');
    if(isGiftwrapper) {
      var message__textarea_lengthEl = isGiftwrapper.find('.gift-message__textarea_length');
      if(message__textarea_lengthEl) {

        var max_rows = 6;
        var value = $(this).val();
        var valueLength = value.length;
        var lines = value.split("\n");
        var count = lines.length;
        
        if(e.keyCode == 13 && count >=6 ) {
          e.preventDefault();
        	return false;
        }
         
        if(count > max_rows) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        } else {
          if(valueLength == 0) {
            var left_lines_str = max_rows + ' line(s) left';
          } else {
            var left_lines_str = max_rows - count + ' line(s) left';
          }
        }
        message__textarea_lengthEl.html(left_lines_str);
       
      }
    }
  });
  

  $('body').on('click', '.show_more_options', function(e) {
	e.preventDefault();
    
    var count = $(this).attr('data-count');
    
    if($(this).hasClass("openedFilter")){     
      $(this).find('.show_more_options_text').html("Show (<span class='total_left_filters_count'>"+count+"</span>) More");
      $(this).removeClass('openedFilter');
      $(this).prev(".advanced-filters").removeClass("showAll");
    }else{
      $(this).prev(".advanced-filters").addClass("showAll");
      $(this).find('.show_more_options_text').html("Less");
      $(this).addClass('openedFilter');
    }
  });
  $('body').on('click', '.activeFilter', function(e) {
    e.preventDefault();
    var dataName = $(this).attr('data-name');
    var parentForm = $(this).closest('.collection-filters-form');
    var dataValue = $(this).attr('data-value');
    var checkedInput = parentForm.find('[name="'+dataName+'"][value="'+dataValue+'"]:checked');
    if(checkedInput.length) {
      checkedInput.removeAttr('checked');
      checkedInput.prop('checked', false); 
      checkedInput[0].dispatchEvent(new Event('change', { bubbles: true }));
    }
 });
  
  
    $('body').on('click', '.recommendation_collection_product__submit', function(e) {
    e.preventDefault();
      
      var el = $(this);
     
      var itemId = el.attr('data-id');
      el.attr('disabled','disabled');
      var formData = {
        'items': [{
          'id': itemId,
          'quantity': 1
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(function (response) {
        if (response.ok) {
          el.removeAttr('disabled');

          el.addClass('added');

          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));

       
        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('span');
            errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
            errorMessageElement.innerHTML = content['description'];
            el.removeAttr('disabled');
            el[0].insertAdjacentElement('afterend', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
          });
        }
      });


    });
   
  
   $('body').on('click','.mobile_drawer_toggle', function(e) {
     e.preventDefault();
     $(this).toggleClass('active');
     var parent = $(this).closest('.Drawer');
     var heading = $(this).find('.mobile_drawer_toggle__heading');
     parent.toggleClass('open_upsell');
     if($(this).hasClass('active')) {
       heading.html("Your Bag");
     } else {
       heading.html("Pair With");
     }
   });
  
  
  $('body').on('click','.recommendation_drawer_products_Close', function(e) {
    e.preventDefault();

    var parent = $(this).closest('.Drawer');
    var heading = parent.find('.mobile_drawer_toggle__heading');
    var mobile_drawer_toggleEl  = parent.find('.mobile_drawer_toggle'); 
    parent.toggleClass('open_upsell');
    mobile_drawer_toggleEl.toggleClass('active');
    if(mobile_drawer_toggleEl.hasClass('active')) {
      heading.html("Your Bag");
    } else {
      heading.html("Pair With");
    }

  });

  


  let tickerSlideshows = document.querySelectorAll('.ticker-slideshow');
  if(tickerSlideshows.length) {
    console.log(tickerSlideshows)
    tickerSlideshows.forEach((element) => {
      //
      //   Variables
      //
      //////////////////////////////////////////////////////////////////////

      // Play with this value to change the speed
      let tickerSpeed = 1;

      let tickerFlickity = null;
      let isPaused = false;
      let slideshowEl = element;

      if (slideshowEl != null) {
        //
        //   Functions
        //
        //////////////////////////////////////////////////////////////////////

        let update = () => {
          if (isPaused) return;
          if (tickerFlickity.slides) {
            tickerFlickity.x = (tickerFlickity.x - tickerSpeed) % tickerFlickity.slideableWidth;
            tickerFlickity.selectedIndex = tickerFlickity.dragEndRestingSelect();
            tickerFlickity.updateSelectedSlide();
            tickerFlickity.settle(tickerFlickity.x);
          }
          window.requestAnimationFrame(update);
        };

        let pause = () => {
          isPaused = true;
        };

        let play = () => {
          if (isPaused) {
            isPaused = false;
            window.requestAnimationFrame(update);
          }
        };


        //
        //   Create Flickity
        //
        //////////////////////////////////////////////////////////////////////

        tickerFlickity = new Flickity(slideshowEl, {
          autoPlay: false,
          prevNextButtons: false,
          pageDots: false,
          draggable: true,
          wrapAround: true,
          selectedAttraction: 0.015,
          friction: 0.25
        });
        tickerFlickity.x = 0;
        slideshowEl.classList.add('rendered');




        //
        //   Start Ticker
        //
        //////////////////////////////////////////////////////////////////////

        update();
      }
    });
  }


  $('body').on('click', '.product_qty_error_popup__close', function(e) {
    e.preventDefault();
    $(this).closest('.product_qty_error_popup').removeClass('show');
  });
  document.addEventListener('click', function(e) {
    var el = e.target;

    if(el.classList.contains('product_qty_error_popup__overlay')) {
      e.preventDefault();
      $('.product_qty_error_popup').removeClass('show');
    }
  });


  function repositionMenu () {
    var reposition_MegaMenu__Item_wrapperArr = $('.reposition_MegaMenu__Item_wrapper');
    if(reposition_MegaMenu__Item_wrapperArr.length) {
      reposition_MegaMenu__Item_wrapperArr.each(function () {
        var closestNavLink = $(this).closest('.HorizontalList__Item');
        var MegaMenu__InnerEl = $(this).closest('.MegaMenu__Inner');

        var offset_left = closestNavLink.offset().left;
        var window_width  = window.innerWidth;
        var MegaMenu__InnerElWidth = MegaMenu__InnerEl.width();
        var left_position = offset_left - ((window_width - MegaMenu__InnerElWidth) / 2);
        $(this).css('marginLeft',left_position+'px');
        console.log(left_position);
      });
    }
  }
  repositionMenu();
  window.addEventListener('resize',repositionMenu);
});
 

window.onload = function() { 
  var CheckedColorSwatchItem_arr = document.querySelectorAll('.ColorSwatch__Radio[checked="checked"]');
  
//   if(CheckedColorSwatchItem_arr) {
//     for(var i=0;i < CheckedColorSwatchItem_arr.length;i++) {
//       var CheckedColorSwatchItem = CheckedColorSwatchItem_arr[i];
//       CheckedColorSwatchItem.checked = true;
//       CheckedColorSwatchItem.click();
      
//     }
//   }

  if(window.location.href.indexOf('/challenge#footer-newsletter') >= 0) {
    setTimeout(function() {
      if(window.scrollY != 0) {
        $(window).scrollTop(0);
      }
    },1000);

  }

};



(function($, VoiceTranscription) {
  Shopify.voiceSearch = {
    attached: false,
    attach: function() {
      // Search result pages load the nav utility twice, this is to prevent duplication.
      if (!this.attached) {
        if ('webkitSpeechRecognition' in window) {
          initVoice();
        } else {
          $('.js-voice-search').remove();
        }
        this.attached = true;
      } 
      function initVoice() {
        // DOM Objects w/o/Events.
        var $micOverlay = $('.Search-by-voice-popup'),
            $searchField = $('input.js-predictive-search-input'),
            $micOverlayOutput = $('.Search-by-voice-popup-output-result'),
			      $micOverlayOutputText = $('.Search-by-voice-popup-output-text'),
            $btnMic = $('.js-voice-search'),
            $micOverlayClose = $('.Search-by-voice-popup-close'),
            $submitForm = $('.js-predictive-search-form');

         this.isListening = false;    
        var speechPhrases = $micOverlay.attr("data-suggestions").split(",") || [];

          var searchQueryStr = "";
          var recognition = new webkitSpeechRecognition();
          recognition.lang = $("#localization_form_header button.is-selected").val();
          recognition.interimResults = true;


          recognition.addEventListener('end', onListenSuccess.bind(this));
          recognition.addEventListener('result', handleResult.bind(this));
          recognition.addEventListener('error', onListenError);


          function handleResult({results}) {
            const result = Array.from(results).reduce((str, result) => {
                return str + ' ' + result[0].transcript;
            }, '');
            searchQueryStr = result.trim();
            recognition.stop();
          }
        function onListenError() { // Microphone w/o permissions.
           $btnMic.removeClass('active');
           $micOverlay.removeClass('show');
           $("#cutom-page_back-top-button").show();
           recognition.stop();
           this.isListening = false;
        }

        function onListenSuccess() {
              this.isListening = false;
              recognition.stop();
              if(searchQueryStr == ""){
                  $btnMic.removeClass('active');
                  $micOverlay.removeClass('show');
                  $("#cutom-page_back-top-button").show(); 
                  return;
              }
              var result_text = '"' + searchQueryStr + '"';      
              $(".Search-by-voice-popup-title").text("Searching");
              $micOverlayOutput.text(result_text);
              $micOverlayOutputText.text("Please wait...");
			  $(".Search-by-voice-popup-image, .Search-by-voice-popup-list-title, .Search-by-voice-popup-list").hide();
              $searchField.val(searchQueryStr);
              setTimeout(() => {
              $submitForm.submit(); // Force submit the form.
              },1000); 
        }

        $btnMic.on('click', function(e) {
          this.isListening = true;
          e.preventDefault();
          $btnMic.addClass('active');
          $micOverlay.addClass('show');
          $("#cutom-page_back-top-button").hide();
          searchQueryStr = "";
          recognition.start();
          setTimeout(() => {
            if(this.isListening){
            recognition.stop();
            $btnMic.removeClass('active');
            $micOverlay.removeClass('show');
            $("#cutom-page_back-top-button").show();
            }
          },4000); 

        });

        $micOverlayClose.on('click', function() {
          recognition.stop();
          this.isListening = false;
          $btnMic.removeClass('active');
          $micOverlay.removeClass('show');
          $("#cutom-page_back-top-button").show();
        });

      }
    }
  };
})(jQuery);
Shopify.voiceSearch.attach();


   
  var headers = new Headers({ 'Content-Type': 'application/json' });
  var request = {
            method: 'GET',
            headers: headers
          };  
    
  var checkNotes = function(){
   fetch('/cart.js', request)
        .then(response => response.json())
        .then(data => { 
     
       var time_note = localStorage.getItem('cart note time');
       var date_now = new Date().getTime();
       var data_difference = (date_now - (time_note*1))/1000/60; 

     
     if((data.items.length > 0 && data_difference >= 120) || ( data.items.length == 0 && data_difference >= 120)){    
       localStorage.removeItem ('cart note time');
       
      
           fetch("".concat(window.routes.cartUrl, "/update.js"), {
             body: JSON.stringify({
               note: ""
             }),
             credentials: 'same-origin',
             method: 'POST',
             headers: {
               'Content-Type': 'application/json',
               'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

             }
           }).then(function (content) {
             content.json().then(function (cart) {


               var giftMessageButtonContentEl = $('.cart-gift-message__button-content');
               if(giftMessageButtonContentEl.length) {
                 giftMessageButtonContentEl.html('Add a personal note');
               }
             })
           });
       
     }
   });
   
  }
  
 function doCheck(){
      setTimeout(function(){
       var time_note = localStorage.getItem('cart note time');
        if (time_note != null){
          checkNotes();
          doCheck();
        }
      }, 1000);
    };  
 doCheck()   
 
  function doCheckDoubly(){
      setTimeout(function(){
        if ($(".doubly-wrapper").length){
        $(".header_doubly-wrapper").append($(".doubly-wrapper"));
        }else{
          doCheckDoubly();
        }
      }, 200);
    };  
 doCheckDoubly();   
 
 




document.addEventListener("DOMContentLoaded", function() {
 $('.ProductItem__InfoRow').matchHeight();
});